import { RouteItem } from '@eastcoal/router/types/route'

import { INQUIRY_AUCTION_PURCHASE_LIST_PAGE_PATH } from './constants/path'

export const inquiryAuctionPurchaseListRoute: RouteItem = {
  title: '询比价',
  path: INQUIRY_AUCTION_PURCHASE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
